// The nationalities collection stores UnionEuropeenne as 0/1 while the Mongoose
// schema declares a Boolean: both forms must count as EU.
export const isEuNationality = (nationality) => Number(nationality?.UnionEuropeenne) === 1;

// An unpopulated reference (bare id) carries no label nor EU flag: treat it as absent.
const isNationalityDocument = (nationality) =>
  nationality !== null && typeof nationality === 'object';

export const isNonEuNationality = (nationality) =>
  isNationalityDocument(nationality) && !isEuNationality(nationality);

const translate = (language, key, fallback) => language?.getValue?.(key, fallback) ?? fallback;

/**
 * '<label> · <area>' text, as shown in the nationality options of IdentityCorrection.
 * @param {object} summary - { label, isEu }
 * @param {object} language - Language instance of the context
 */
export const formatNationalitySummary = ({ label, isEu } = {}, language) => {
  const area = isEu
    ? translate(language, 'identityCorrection.eu', 'UE')
    : translate(language, 'identityCorrection.nonEu', 'Hors UE');
  return label ? `${label} · ${area}` : area;
};

/**
 * Summary of the populated nationality document of a temp worker identity.
 * @param {object|null} nationality - { NationaliteM, NationaliteF, UnionEuropeenne }
 * @param {object} language - Language instance of the context
 */
export const nationalitySummaryText = (nationality, language) => {
  if (!isNationalityDocument(nationality)) {
    return translate(language, 'identityCorrection.notProvided', 'Non renseignée');
  }
  return formatNationalitySummary(
    { label: nationality.NationaliteM, isEu: isEuNationality(nationality) },
    language
  );
};
